/*
 * @Date: 2023-10-27 11:20:11
 * @LastEditors: lihwang_wf@126.com
 * @LastEditTime: 2023-10-30 21:45:22
 * @FilePath: /Client/src/apis/addition.ts
 * @Description:
 */
import { req, get, post } from '@/plugins/axios'
import type { res } from './login'
import { useSite2Station, isD2C, getWarehouseCodeCountry } from '@/store/index'
// 全部附加项列表
interface ALD {
  productType: number | string
  source?: number
  systemSource?: number
}
export const getAdtList = (data: any): Promise<res> =>
  req('/settlement/customer/addition/getAdditionList', {
    ...data,
    stationCode: useSite2Station(),
    systemSource: isD2C() ? 1 : 2
  }).then((res) => {
    const country = getWarehouseCodeCountry(data.warehouseCode) ?? 'CN'
    return {
      ...res,
      data: {
        deliveryAdditionList: res.data?.deliveryAdditionList?.map((v:any) => ({ ...v, country })),
        productAdditionList: res.data?.productAdditionList?.map((v:any) => ({ ...v, country }))
      }
    }
  })

// 后台配置附加项模板
export const getAdtTmpl = (): Promise<res> =>
  get('/customer/additional/getList')

// 附加项辅料
export const getIngredients = (params:any): Promise<res> =>
  req('/order/customer/shop/ingredients/customer/list', params)

// 获取次转正附加项
export const getBadAddition = (data: any): Promise<res> =>
  post('/order/regularization/getBadAddition', data)

// 获取客户附加项配置列表
export const getCustomerAdditionTemplateListApi = (data: any): Promise<res> =>
  post('/settlement/addition/customer/template/pageCustomerAdditionTemplate', data)

// 获取附加项模版详情
export const getAdditionTemplateDetailApi = (data: any): Promise<res> =>
  req('/settlement/addition/customer/template/info', data)

// 添加修改客户附加项模版
export const addCustomerAdditionTemplateApi = (data: any): Promise<res> =>
  post('/settlement/addition/customer/template/addCustomerAdditionTemplate', data)

// 修改客户附加项状态
export const updateCustomerAdditionTemplateStatusApi = (data: any): Promise<res> =>
  post('/settlement/addition/customer/template/updateCustomerAdditionTemplateStatus', data)

// 修改客户附加项状态
export const updateCustomerAdditionTemplateApi = (data: any): Promise<res> =>
  post('/settlement/addition/customer/template/updateCustomerAdditionTemplate', data)

// 客户附加项列表
export const getCustomerAdditionListApi = (data: any): Promise<res> =>
  req('/settlement/addition/customer/template/listCustomerAdditionTemplate', data)

// 客户的费率信息
export const getRateByMemberShipId = (data: any): Promise<res> =>
  req('settlement/selling/price/setting/getRateByMemberShipId', data)

// 查询库存不足的辅料(前台)
export const selectInsufficientInventory = (): Promise<res> =>
  get('/order/customer/shop/ingredients/selectInsufficientInventory')

export const updateEarlyWarningFlag = (data:any): Promise<res> =>
  post('/order/customer/shop/ingredients/updateEarlyWarningFlag', data)

export const getAdditionFeeStandardApi = (data:any): Promise<res> =>
  req('/settlement/customer/addition/getAdditionFeeStandard', data)